import { ReferenceField, TextField } from "react-admin";
import * as React from "react";
import { SourceCustomer } from "../../../Pages/Admin/Customer";

const CustomerField = props => {
  return (
    <ReferenceField label="CUSTOMER INFO" source="customerId" reference={SourceCustomer} {...props}>
      <TextField source="customerName" />
    </ReferenceField>
  );
};

export default CustomerField;
